import React from 'react';

const FilterIconBack = () => {
    return (
        <svg width="63" height="52" viewBox="0 0 63 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4119_31053)">
                <rect width="63" height="52" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_4119_31053">
                    <rect width="63" height="52" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default FilterIconBack;